import { render, staticRenderFns } from "./BadgrSettings.vue?vue&type=template&id=59c9a407&scoped=true"
import script from "./BadgrSettings.vue?vue&type=script&lang=js"
export * from "./BadgrSettings.vue?vue&type=script&lang=js"
import style0 from "./BadgrSettings.vue?vue&type=style&index=0&id=59c9a407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c9a407",
  null
  
)

export default component.exports